export default __webpack_public_path__ + "static/hero_student-051c5b4ef38fa8f825881c6f093db7fb.jpg";